import { Box } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";

const settings = {
  width: 200,
  height: 200,
};

export default function TransactionChart({ value, text }) {
  return (
    <Box position="relative" width={settings.width} height={settings.height}>
      {/* Outer Gauge */}
      <Gauge
        {...settings}
        value={value}
        valueMax={500}
        innerRadius="60%"
        outerRadius="99%"
        cornerRadius="15%"
        startAngle={90}
        endAngle={450}
        sx={{
          [`& .${gaugeClasses.valueArc}`]: {
            fill: "#fff",
          },
          [`& .${gaugeClasses.referenceArc}`]: {
            fill: "transparent",
          },
          [`& .${gaugeClasses.valueText}`]: {
            display: "none",
          },
        }}
      />

      {/* Inner Gauge with styled text */}
      <Gauge
        {...settings}
        value={value}
        valueMax={500}
        innerRadius="70%"
        outerRadius="89%"
        cornerRadius="50%"
        startAngle={90}
        endAngle={450}
        text={() => `${value}\n${text}`} // use line break
        sx={{
          [`& .${gaugeClasses.valueArc}`]: {
            fill: "#fff",
          },
          [`& .${gaugeClasses.referenceArc}`]: {
            fill: "#FFFFFF50",
          },
          [`& .${gaugeClasses.valueText} tspan:first-of-type`]: {
            fontSize: "16px",
            fontWeight: "bold",
          },
          [`& .${gaugeClasses.valueText} tspan:last-of-type`]: {
            fontSize: "15px",

          },
          [`& .${gaugeClasses.valueText} text`]: {
            fill: "#fff",
            whiteSpace: "pre-line",
            textAnchor: "middle",
            dominantBaseline: "central",
          },
        }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
        }}
      />
    </Box>
  );
}
